import Vue from 'vue'
import App from './App.vue'
import utils from './utils/urlGet'
// import http from "@/assets/utils/http";
import global_ from './views/Global'
import store from './store'
import router from './router'
import fastClick from 'fastclick'
import axios from 'axios'
import http from './utils/http'
import '@vant/touch-emulator'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { Button } from 'vant'
import { Lazyload } from 'vant'
import { Icon } from 'vant'
import { Tab, Tabs } from 'vant'
import { Loading } from 'vant'
import { Uploader } from 'vant'
import { Toast } from 'vant'
import { List } from 'vant'
import VueBus from 'vue-bus'
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)

import './assets/styles/reset.css'
import './assets/styles/border.css'
import 'swiper/dist/css/swiper.css'

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.config.productionTip = false
fastClick.attach(document.body)
Vue.use(VueAwesomeSwiper)
Vue.prototype.$utils = utils
Vue.prototype.$http = http
Vue.prototype.GLOBAL = global_
// axios.defaults.baseURL = global_.BASE_URL
Vue.prototype.$ajax = axios
Vue.prototype.hasLogin = false
Vue.prototype.game_id = false
Vue.prototype.isCur = true
Vue.prototype.isActive = false
Vue.prototype.isLeftLine = true
Vue.prototype.isRightLine = true
Vue.use(Button)
Vue.use(Lazyload)
Vue.use(Icon)
Vue.use(Tab).use(Tabs)
Vue.use(Loading)
Vue.use(VueQuillEditor)
Vue.use(Uploader)
Vue.use(Toast)
Vue.use(List)
Vue.use(VueBus)




/* axios配置 */
//axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
Vue.prototype.$axios = axios
Vue.prototype.$ajax = axios;

router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
})

Vue.prototype.format = function (fmt, date) {
    let ret;
    let opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        }
    }
    return fmt;
}

function fileHandler(imageSource) {
    store.commit('setIOSImageSource', imageSource);
}


new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')
